/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_BalanceInputs */



/**
* | output |
* | --- |
* | "Remaining" |
*
* @param {Usage_Tab_BalanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_balance = /** @type {((inputs?: Usage_Tab_BalanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_BalanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbleibend")
	return /** @type {LocalizedString} */ ("Remaining")
});